export default "__VITE_ASSET__b8ef92dc__"